export default __webpack_public_path__ + "static/media/react.19465659.svg";